import { render, staticRenderFns } from "./EntityViewHead.vue?vue&type=template&id=45ef9d3a"
import script from "./EntityViewHead.vue?vue&type=script&lang=js"
export * from "./EntityViewHead.vue?vue&type=script&lang=js"
import style0 from "./EntityViewHead.vue?vue&type=style&index=0&id=45ef9d3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports